import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import { useAuth } from '../hooks/useAuth';

export function LoginPage() {
  const { login } = useAuth();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div style={{ width: '100%', maxWidth: 420 }}>
        <Container>
          <SpaceBetween size="l">
            <Box textAlign="center">
              <SpaceBetween size="xxs">
                <Box variant="h1">Manamind</Box>
                <Box variant="p" color="text-body-secondary">
                  Enterprise Knowledge Base
                </Box>
              </SpaceBetween>
            </Box>

            <Button variant="primary" fullWidth onClick={() => login()}>
              Sign in with Enterprise SSO
            </Button>

            <Box textAlign="center" variant="small" color="text-status-inactive">
              Powered by ZTrust Keycloak enterprise SSO
            </Box>
          </SpaceBetween>
        </Container>
      </div>
    </div>
  );
}
